import { render, staticRenderFns } from "./create-independent-program.vue?vue&type=template&id=e5b0d2f2&scoped=true&"
import script from "./create-independent-program.ts?vue&type=script&lang=ts&"
export * from "./create-independent-program.ts?vue&type=script&lang=ts&"
import style0 from "./create-independent-program.scss?vue&type=style&index=0&id=e5b0d2f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b0d2f2",
  null
  
)

export default component.exports